import httpClient from '@/common/http'
export default {
  create(obj) {
    return httpClient.request('post', 'branches', obj);
  },

  update(id, obj) {
    return httpClient.request('put', `branches/${id}`, obj);
  },

  delete(id) {
    return httpClient.request('delete', `branches/${id}`);
  },

  findOne(id) {
    return httpClient.request('get', `branches/${id}`)
  },

  findAll(filter, sort, paginate = {skip: 0, limit: -1}) {
    let query = `${sort}`
    query += (paginate.limit < 1) ? '' : `&skip=${paginate.skip}&limit=${paginate.limit}`
    return httpClient.request('get', `branches?${filter}${query}`)
  }

}